import styled from 'styled-components';

export const Wrapper = styled.div<{ size: 'default' | 'large' }>`
  color: var(--v3-text-color);
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  padding-left: 4px;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  height: 28px;
  direction: ltr;
  ${props =>
    props.size === 'large' &&
    `
        height: 44px;
        min-width: 44px;
    `}
`;
